import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import { AlertCircle } from "lucide-react";
import useMobile from "@/app/hooks/use-mobile";
interface PaymentStepProps {
    errorStr: string;
    onClose: (value: boolean) => void;
}

const ErrorModal: React.FC<PaymentStepProps> = ({ errorStr, onClose }) => {
    const [isOpen, setIsOpen] = useState(true);
    const { isMobile } = useMobile();

    const onClosePopup = () => {
        setIsOpen(false);
        onClose(false);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClosePopup}>
            <DialogContent className="w-[90%] rounded-2xl p-9 md:w-[460px]">
                <VisuallyHidden.Root>
                    <DialogTitle>Error Modal</DialogTitle>
                    <DialogDescription>
                        {errorStr || "An error occurred. Please try again later."}
                    </DialogDescription>
                </VisuallyHidden.Root>
                <div className="w-full">
                    <div className="flex w-full">
                        <AlertCircle className="m-auto h-8 w-8 text-red-500" />
                    </div>
                    <div className="w-full text-center text-xl font-semibold">
                        <div className="flex flex-col items-center justify-center py-3">Error</div>
                    </div>
                    <div className="flex-center flex flex-col items-center">
                        <p className="w-full text-center text-md">
                            {errorStr ?? "An error occurred. Please try again later."}
                        </p>
                    </div>
                </div>
                <RegularButton
                    className="h-16 max-w-full text-lg md:mt-8"
                    label="Ok"
                    noIcon={true}
                    variant={ButtonVariant.PrimaryDefault}
                    size={isMobile ? ButtonSize.Small : ButtonSize.Large}
                    showRightIcon={false}
                    onClick={onClosePopup}
                />
            </DialogContent>
        </Dialog>
    );
};

export default ErrorModal;
